import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogWrapperDataOut, DialogWrapperDataSource } from '../../data-source/dialog-wrapper-data-source';
import { ZvDialogWrapper } from '@zvoove/components/dialog-wrapper';

@Component({
  selector: 'zv-delete-dialog',
  templateUrl: './delete.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ZvDialogWrapper],
})
export class DeleteDialog<TItem, TId> {
  private dialogRef = inject<MatDialogRef<DeleteDialog<TItem, TId>, DialogWrapperDataOut<unknown>>>(MatDialogRef);
  data = inject<DeleteDialogDataIn<TItem, TId>>(MAT_DIALOG_DATA);

  public content =
    this.data.items.length === 1
      ? $localize`:@@general.removeElementText:Wollen Sie das gewählte Element wirklich löschen?`
      : $localize`:@@general.removeElementsText:Wollen Sie die ${this.data.items.length} gewählten Elemente wirklich löschen?`;
  public dwds = new DialogWrapperDataSource({
    dialogRef: this.dialogRef,
    dialogTitle:
      this.data.items.length === 1
        ? $localize`:@@general.removeElement:Element löschen`
        : $localize`:@@general.removeElements:Elemente löschen`,
    actionFn: this.data.actionFn,
    btnConfigFn: (btns) => {
      btns.action.label = $localize`:@@general.delete:Löschen`;
    },
  });

  public itemNames = this.data.items.map((x) => this.data.nameFn(x));
}

export interface DeleteDialogDataIn<TItem, TId> {
  items: TItem[];
  nameFn: (item: TItem) => string;
  idFn: (item: TItem) => TId;
  actionFn: () => Observable<unknown>;
}
